export default {"src":"/_next/static/media/right_curve.12514c03.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};